import { Box, Typography, Stack } from '@mui/material';
import { Page } from '../../../components';
import { LoginForm } from '../components';
import useResponsive from '../../../hooks/useResponsive';

const BRAND_RED = '#E31E24';
const BRAND_GREEN = '#1E5132';

export default function Login() {
  const mdUp = useResponsive('up', 'md');

  return (
    <Page title="Login">
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        {/* ── Left panel (desktop only) ── */}
        {mdUp && (
          <Box
            sx={{
              width: '50%',
              background: `linear-gradient(160deg, ${BRAND_GREEN} 0%, #163d26 60%, #0e2718 100%)`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              p: 8,
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Decorative circles */}
            <Box
              sx={{
                position: 'absolute',
                width: 400,
                height: 400,
                borderRadius: '50%',
                border: `1px solid rgba(255,255,255,0.08)`,
                top: -80,
                left: -80,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                width: 300,
                height: 300,
                borderRadius: '50%',
                border: `1px solid rgba(255,255,255,0.06)`,
                bottom: -60,
                right: -60,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                width: 200,
                height: 200,
                borderRadius: '50%',
                bgcolor: BRAND_RED,
                opacity: 0.12,
                top: '30%',
                right: -40,
              }}
            />

            <Stack spacing={4} alignItems="center" sx={{ position: 'relative', zIndex: 1 }}>
              <Box
                component="img"
                src="https://www.quickmart.co.ke/image/site-logo/1?t=1776045101.jpg"
                alt="Quickmart"
                sx={{ width: 260, filter: 'brightness(0) invert(1)' }}
              />
              <Box sx={{ width: 48, height: 3, bgcolor: BRAND_RED, borderRadius: 2 }} />
              <Typography
                variant="h4"
                sx={{ color: '#fff', fontWeight: 700, textAlign: 'center', lineHeight: 1.3 }}
              >
                Asset Management
                <br />
                System
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'rgba(255,255,255,0.6)', textAlign: 'center', maxWidth: 320 }}
              >
                Track, manage and maintain your assets across all Quickmart branches from one place.
              </Typography>
            </Stack>
          </Box>
        )}

        {/* ── Right panel (form) ── */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#f7f8fa',
            p: { xs: 3, sm: 6 },
          }}
        >
          {/* Mobile logo */}
          {!mdUp && (
            <Box
              component="img"
              src="https://www.quickmart.co.ke/image/site-logo/1?t=1776045101.jpg"
              alt="Quickmart"
              sx={{ width: 200, mb: 4 }}
            />
          )}

          <Box
            sx={{
              width: '100%',
              maxWidth: 440,
              bgcolor: '#fff',
              borderRadius: 3,
              boxShadow: '0 8px 40px rgba(0,0,0,0.10)',
              p: { xs: 3, sm: 5 },
            }}
          >
            {/* Card header accent */}
            <Box
              sx={{
                height: 5,
                borderRadius: '4px 4px 0 0',
                background: `linear-gradient(90deg, ${BRAND_RED} 0%, ${BRAND_GREEN} 100%)`,
                mx: -5,
                mt: -5,
                mb: 4,
              }}
            />

            <Stack spacing={1} sx={{ mb: 4 }}>
              <Typography variant="h5" fontWeight={700} color="text.primary">
                Welcome back
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sign in to your account to continue
              </Typography>
            </Stack>

            <LoginForm />
          </Box>

          <Typography variant="caption" color="text.disabled" sx={{ mt: 4 }}>
            &copy; {new Date().getFullYear()} Quickmart. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </Page>
  );
}
